import type { FC } from 'react';
import { Backdrop } from '@mui/material';

import { TMoplaColors } from '@mopla/mui';

import { StyledCircularProgress } from './MplLoader.styles';

interface IMplLoaderProps {
	isLoading: boolean;
	loaderColor?: TMoplaColors;
}

export const MplLoader: FC<IMplLoaderProps> = ({
	isLoading,
	loaderColor = 'primary.light',
}) => (
	<Backdrop sx={{ zIndex: 3000 }} open={isLoading}>
		<StyledCircularProgress loaderColor={loaderColor} />
	</Backdrop>
);
